module.exports = __webpack_public_path__ + "img/heiyan.f0ef89ce.png";